export enum CVA_AUTH_MODULES {
  CVA_SOAP_NOTES = 'cva-soap-notes',
  CVA_CUSTOM_TEMPLATE = 'cva-custom-template',
  CVA_PRACTITIONER = 'cva-practitioner',
  CVA_LICENSE_MANAGEMENT = 'cva-license-management',
  CVA_SUBSCRIBE = 'cva-subscription',
  CVA_SYSTEM_TEMPLATE_MANAGEMENT = 'cva-system-template-mgmt'
}
